import React from 'react';

import dentalCritiqueTestimonialImage from '@/assets/images/testimonials/dental-critique.png';
import eliteDentalTestimonialImage from '@/assets/images/testimonials/elite.png';
import happyGreenTestimonialImage from '@/assets/images/testimonials/happy-green.png';
import Anchor from '@/components/common/anchor/Anchor';
import SectionHeader from '@/components/common/sectionHeader/SectionHeader';
import Spacer from '@/components/common/spacer/Spacer';
import TestimonialCard from '@/components/landingPage/testimonials/testimonialCard/TestimonialCard';
import { TestimonialItem } from '@/utils/types';

import './Testimonials.css';

interface TestimonialsProps {
  showHeader?: boolean;
  header?: string;
}

const Testimonials: React.FC<TestimonialsProps> = ({
  showHeader = true,
  header = 'Loved by Dentists'
}) => {
  const testimonials: TestimonialItem[] = [
    {
      id: 1,
      content: (
        <>
          Patient booking becomes hassle free. We have no worries in patient
          cancellation since the app itself sends a reminder to every patient —
          making sure{' '}
          <span className="highlight">
            the patient is reminded of their appointment and literally shows up.
          </span>{' '}
          That's the best feature!
        </>
      ),
      author: 'Dr. Costa',
      clinic: 'Elite Dental',
      image: eliteDentalTestimonialImage
    },
    {
      id: 2,
      content: (
        <>
          It helped me big time in my clinic scheduling.{' '}
          <span className="highlight">
            No hassle and no more overlapping of patient.
          </span>{' '}
          It became my official booking link.
        </>
      ),
      author: 'Dr. Abella',
      clinic: 'Dental Critique',
      image: dentalCritiqueTestimonialImage
    },
    {
      id: 3,
      content: (
        <>
          It's been a game-changer. My team collaborates so much better,
          patients are happier with the communication, and I{' '}
          <span className="highlight">spend way less time on admin work.</span>{' '}
          Couldn't imagine going back!
        </>
      ),
      author: 'Dr. Gener',
      clinic: 'Happy Green',
      image: happyGreenTestimonialImage
    }
  ];

  return (
    <div id="testimonials">
      <Anchor id="toTestimonials" />
      {showHeader && <SectionHeader>{header}</SectionHeader>}
      <Spacer top={16} />
      <div className="testimonialsContainer">
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={testimonial.id}
            testimonial={testimonial}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
